import './radio.scss';

import { forwardRef } from 'react';

import { RadioProps } from '../RadioGroup/types/RadioProps';

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ label, labelPlacement = 'beside', loading, ...props }, ref) => {
    const className = [
      'radio',
      props.checked && 'radio-selected',
      labelPlacement === 'beside' ? 'radio-horizontal' : 'radio-vertical',
      loading && 'loading',
      props.className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <label className={className}>
        <input {...props} ref={ref} role="radio" type="radio" />
        <span className="radio-inner-circle" />
        <span>{label}</span>
      </label>
    );
  },
);
